/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useEffect, useState } from "react";

export default function useMerchantsReviews(baseUrl) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setLoading(true);

        const tenantId = -1;

        const res = await fetch(
          `${baseUrl}/TenantnNotifications?tenantId=${tenantId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        let data = [];
        try {
          data = await res.json();
        } catch {
          data = [];
        }

        if (res.ok && Array.isArray(data)) {
          const mapped = data
            .filter((notif) => notif.IsActive === 1) // ✅ فقط المقبول
            .map((notif) => {
              const hasImage = notif.hasImage;
              const rawImageUrl = notif.imageUrl;
        
              const img =
                hasImage &&
                rawImageUrl &&
                typeof rawImageUrl === "string" &&
                rawImageUrl.trim() !== ""
                  ? rawImageUrl
                  : null;
        
              return {
                id: notif.Id || notif.id || 0,
                name: notif.merchantName || notif.tenantName || "",
                store: notif.tenantName || "",
                rate: notif.rating || 0,
                text: notif.Description || notif.description || "",
                img,
              };
            });
        
          setReviews(mapped);
        } else {
          setReviews([]);
        }
      } catch {
        setReviews([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [baseUrl]);

  return { reviews, loading };
}
